import { AppLogoIcon } from '../../icons/AppLogoIcon'
import { PlaylistWidgetPlayer } from '../article/components/PlaylistWidgetPlayer'
import { AppIconAndHyperlinkContainer } from './styled/AppIconAndHyperlinkContainer.styled'
import { WebsiteHyperlink } from './styled/WebsiteHyperlink.styled'
import { PlaylistWidgetContainer } from './styled/PlaylistWidgetContainer.styled'
import { WebsiteHyperlinkContainer } from './styled/WebsiteHyperlinkContainer.styled'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { fetchArticlesThunk, selectCurrentlyPlayingArticle, selectLinkToNoa } from '../article/data/articleSlice'
import { WebsiteHyperlinkText } from './styled/WebsiteHyperlinkText.styled'
import { WidgetFixedHeader } from './styled/WidgetFixedHeader.styled'
import { WidgetArticlesContainer } from './styled/WidgetArticlesContainer'
import { AudioPlayer } from '../audio/AudioPlayer'
import { selectTheme, setTheme } from '../theme/data/themeSlice'
import { ThemeProvider } from 'styled-components'
import MpTrackingButtons from '../../tracking/types/mpTrackingButtons'
import { mpInit, mpTrackButtonClick } from '../../tracking/mixpanel'
import { Scrollbars } from 'react-custom-scrollbars-2'
import Application from '../application/Application'
import themeUtils from '../theme/data/themeUtils'
import { PoweredBy } from './styled/PoweredBy'
import { StyledMobileIcon } from '../../icons/MobileIcon'
import { MoreArticlesText } from './styled/MoreArticlesText'
import {
    selectClickHereCtaLink,
    selectClickHereCtaText,
    selectIsListenOnEnabled,
    selectListenOnText,
    setApplicationOptions,
} from '../application/applicationSlice'
import { useEffect } from 'react'
import useQueueMain from '../queue/hooks/useQueue'

export const PlaylistWidget = () => {
    const dispatch = useAppDispatch()

    const theme = useAppSelector(selectTheme)
    const linkToNoa = useAppSelector(selectLinkToNoa)
    const currentlyPlayingArticle = useAppSelector(selectCurrentlyPlayingArticle)
    const isListenOnEnabled = useAppSelector(selectIsListenOnEnabled)
    const clickHereCtaText = useAppSelector(selectClickHereCtaText)
    const listenOnText = useAppSelector(selectListenOnText)
    const clickHereCtaLink = useAppSelector(selectClickHereCtaLink)

    useQueueMain()

    useEffect(() => {
        dispatch(fetchArticlesThunk())
        dispatch(setTheme())
        dispatch(setApplicationOptions())
        mpInit()
    }, [])

    return (
        <ThemeProvider theme={{ ...theme, ...themeUtils }}>
            <PlaylistWidgetContainer>
                <WidgetFixedHeader>
                    <div style={{ padding: '0px 15px' }}>
                        <WebsiteHyperlink
                            href={linkToNoa}
                            target='_blank'
                            onClick={() =>
                                mpTrackButtonClick(MpTrackingButtons.NAVIGATE_TO_NOA, currentlyPlayingArticle)
                            }>
                            <AppIconAndHyperlinkContainer>
                                <PoweredBy>
                                    <p>Powered by</p>
                                    <AppLogoIcon height={24} width={65} />
                                </PoweredBy>
                                {isListenOnEnabled && (
                                    <WebsiteHyperlinkContainer>
                                        <WebsiteHyperlinkText>{listenOnText}</WebsiteHyperlinkText>
                                        <StyledMobileIcon />
                                    </WebsiteHyperlinkContainer>
                                )}
                            </AppIconAndHyperlinkContainer>
                        </WebsiteHyperlink>
                    </div>
                    {currentlyPlayingArticle != null && <PlaylistWidgetPlayer article={currentlyPlayingArticle} />}
                </WidgetFixedHeader>
                <Scrollbars
                    style={{ zIndex: 0, background: theme.bgColor }}
                    hideTracksWhenNotNeeded
                    renderTrackVertical={({ style, ...props }) => (
                        <div
                            {...props}
                            style={{
                                ...style,
                                backgroundColor: theme.scrollbarBgColor,
                                width: 8,
                                right: 0,
                                height: '100%',
                                borderRadius: 8,
                            }}
                        />
                    )}
                    renderThumbVertical={({ style, ...props }) => (
                        <div
                            {...props}
                            style={{
                                ...style,
                                backgroundColor: theme.scrollbarColor,
                                width: 8,
                                right: 0,
                                height: '100%',
                                borderRadius: 8,
                            }}
                        />
                    )}>
                    <WidgetArticlesContainer>
                        <Application />
                    </WidgetArticlesContainer>
                </Scrollbars>

                <AudioPlayer />
                <MoreArticlesText
                    href={clickHereCtaLink}
                    onClick={() => mpTrackButtonClick(MpTrackingButtons.CLICK_HERE_CTA, currentlyPlayingArticle)}
                    target='_black'>
                    {clickHereCtaText}
                </MoreArticlesText>
            </PlaylistWidgetContainer>
        </ThemeProvider>
    )
}
